import { render, staticRenderFns } from "./Sunflower.vue?vue&type=template&id=6f6c98bd&scoped=true&"
import script from "./Sunflower.vue?vue&type=script&lang=js&"
export * from "./Sunflower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6c98bd",
  null
  
)

export default component.exports